var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.297,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 11.243a6.987 6.987 0 01-4.836-2.7A17.719 17.719 0 0121.85.005c3.854 0 9.314 4.194 8.332 8.538-1.582 7-12.917 24.234-20.478 27.028-4.445 1.645-7.675-1.662-9.7-5.2.246-2.657 6.1-7.559 6.933-7.3a5.749 5.749 0 013.868 3.683l11.438-15.5z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephony);
export default __webpack_public_path__ + "static/media/telephony.ab6d2ca0d94f88e3b806c50b3e3153da.svg";
export { ForwardRef as ReactComponent };